import a, { forwardRef as H, createElement as Q, useState as T, useEffect as U, useCallback as _, useMemo as $, useRef as S, useId as X, useImperativeHandle as Y } from "react";
import { t as P, c as v } from "./useKeyDown-88662051.mjs";
import { u as Z } from "./useClickOutside-55c64a80.mjs";
import { I as O, W as R } from "./Icon-e01b6482.mjs";
import { a as A } from "./index-615eb227.mjs";
const ee = "dropdown", te = "dropdown__button", oe = "dropdown__count-badge", ne = "dropdown__button--large", se = "dropdown__button--disabled", re = "dropdown__filter", ae = "mobile", de = "dropdown__list", le = "desktop", ce = "dropdown__list-item", ue = "dropdown__list-empty-message", ie = "dropdown__checkbox", pe = "dropdown__button--open", I = {
  dropdown: ee,
  dropdownButton: te,
  dropdownCountBadge: oe,
  dropdownButtonLarge: ne,
  dropdownButtonDisabled: se,
  dropdownFilter: re,
  mobile: ae,
  dropdownList: de,
  desktop: le,
  dropdownListItem: ce,
  dropdownListEmptyMessage: ue,
  dropdownCheckbox: ie,
  dropdownButtonOpen: pe
}, me = H(function({
  isOpen: e,
  selectedItems: t,
  label: n,
  onClick: s,
  isLarge: d,
  isMulti: i,
  className: l,
  ...u
}, p) {
  const B = t.length, m = A(
    (b) => {
      b.stopPropagation(), s?.(b);
    }
  ), { disabled: x } = { ...u }, h = typeof n == "string" ? /* @__PURE__ */ a.createElement(
    "label",
    {
      className: e ? P.textsLeadTextBold : P.textsLeadText
    },
    i ? /* @__PURE__ */ a.createElement("span", null, n, " ", /* @__PURE__ */ a.createElement(W, { count: B })) : /* @__PURE__ */ a.createElement("span", null, t[0]?.label || n)
  ) : Q(n, { isOpen: e, selectedItems: t, isMulti: i });
  return /* @__PURE__ */ a.createElement(
    "button",
    {
      "data-testid": "dropdown-button",
      "aria-label": n.toString(),
      className: v(
        I.dropdownButton,
        d && I.dropdownButtonLarge,
        x && I.dropdownButtonDisabled,
        e && I.dropdownButtonOpen,
        l
      ),
      type: "button",
      ...u,
      onClick: m,
      ref: p
    },
    h,
    /* @__PURE__ */ a.createElement(
      O,
      {
        icon: e ? R.CHEVRON_UP : R.CHEVRON_DOWN,
        size: 16
      }
    )
  );
}), we = H(function({
  isOpen: e,
  getItemProps: t,
  checkSelected: n,
  items: s,
  highlightedIndex: d,
  emptyMessage: i,
  isMulti: l,
  className: u,
  name: p,
  showFilterInput: B = !1,
  ...m
}, x) {
  const [h, b] = T(""), C = h ? s?.filter((r) => {
    if (r && r.label)
      return r.label.toLowerCase().startsWith(h.toLowerCase());
  }) : s, E = (r) => {
    const c = r.target.value, f = c.charAt(0).toUpperCase() + c.slice(1);
    b(f);
  };
  return U(() => {
    e || b("");
  }, [e]), /* @__PURE__ */ a.createElement(a.Fragment, null, e && B && /* @__PURE__ */ a.createElement(
    "input",
    {
      type: "text",
      value: h,
      onChange: E,
      tabIndex: e ? 0 : -1,
      className: v(I.dropdownFilter, P.textsLeadTextBold),
      autoFocus: e
    }
  ), /* @__PURE__ */ a.createElement(
    "ul",
    {
      ...m,
      className: v(I.dropdownList, u),
      ref: x,
      "data-testid": "dropdown-list",
      hidden: !e
    },
    C.length > 0 ? C.map((r, c) => {
      const f = n(r.value);
      return /* @__PURE__ */ a.createElement(
        "li",
        {
          className: I.dropdownListItem,
          "data-highlighted": d === c,
          key: `${r.value}${c}`,
          "aria-selected": f,
          ...t({ item: r.value, index: c }),
          "data-testid": "dropdown-list-item-" + c,
          tabIndex: 0
        },
        l ? /* @__PURE__ */ a.createElement(fe, { checked: f }) : null,
        /* @__PURE__ */ a.createElement("label", { className: v(P.textsLeadText) }, r.label, r.count ? /* @__PURE__ */ a.createElement(W, { count: r.count }) : null),
        p ? /* @__PURE__ */ a.createElement(
          "input",
          {
            hidden: !0,
            key: r.value,
            name: p,
            checked: f,
            value: r.value,
            type: l ? "checkbox" : "radio",
            onChange: ge
          }
        ) : null
      );
    }) : /* @__PURE__ */ a.createElement("p", { className: I.dropdownListEmptyMessage }, i)
  ));
});
function fe({ checked: o = !1 }) {
  return /* @__PURE__ */ a.createElement("div", { className: I.dropdownCheckbox, "aria-checked": o }, o && /* @__PURE__ */ a.createElement(O, { icon: R.CHECK }));
}
function W({ count: o }) {
  return /* @__PURE__ */ a.createElement("div", { className: I.dropdownCountBadge, "aria-hidden": "true" }, /* @__PURE__ */ a.createElement("span", { className: P.textsCaption }, o));
}
function ge() {
}
function z(o, e) {
  const t = e?.replace(/\s/g, "-").replace(/[^\w]/gi, "");
  return `dropdown-${o}-list-item-${t}`;
}
function he(o, e, t, n) {
  const s = () => t(0), d = () => t(e - 1), i = () => t((u) => Math.min(u + 1, e - 1)), l = () => t((u) => Math.max(0, u - 1));
  if (o.key === "Tab") {
    o.preventDefault(), o.shiftKey ? l() : i();
    return;
  }
  if (o.key === "ArrowDown") {
    o.preventDefault(), o.metaKey ? d() : i();
    return;
  }
  if (o.key === "ArrowUp") {
    o.preventDefault(), o.metaKey ? s() : l();
    return;
  }
  if (o.key === "Enter" || o.key === " ")
    return o.preventDefault(), n();
}
function be(o, e) {
  const [t, n] = T(0), s = _(
    () => e[t],
    [e, t]
  ), d = $(
    () => z(o, s()?.value),
    [o, s]
  );
  return {
    highlightedIndex: t,
    highlightedItemId: d,
    setHighlightedIndex: n,
    getItemFromHighlightedIndex: s
  };
}
function Ie(o, e, t, n) {
  const [s, d] = T(!1), i = _(
    (p = 0) => {
      d(!0), n?.(!0), e.current?.focus(), t(p);
    },
    [e, n, t]
  ), l = _(
    (p = !1) => {
      d(!1), n?.(!1), p && o.current?.focus();
    },
    [o, n]
  ), u = A(
    () => s ? l(!0) : i(0)
  );
  return { isOpen: s, openMenu: i, closeMenu: l, toggleMenu: u };
}
function Ee(o, e) {
  const t = T(
    () => new Set(
      (e || o || []).map(
        (s) => s.value
      )
    )
  ), n = t[1];
  return U(() => {
    e && n((s) => (s.clear(), e.forEach((d) => s.add(d.value)), s));
  }, [e, n]), t;
}
function ke(o, e, t) {
  const n = S(!1);
  return U(() => {
    if (t)
      return;
    const s = e.current?.querySelector("#" + o);
    n.current && s?.scrollIntoView({
      block: "nearest",
      inline: "nearest",
      behavior: "smooth"
    });
  }, [t, o, e]), n;
}
function ye(o) {
  const {
    id: e,
    items: t = [],
    initialSelectedItems: n,
    selectedItems: s,
    enableCloseOnSelect: d = !1,
    onOpenStateChange: i,
    onSelectedItemsChange: l,
    isMulti: u = !0,
    disabled: p
  } = o, B = X(), m = (e || B).replace(/:/g, ""), x = S(null), h = S(null), {
    highlightedIndex: b,
    highlightedItemId: C,
    setHighlightedIndex: E,
    getItemFromHighlightedIndex: r
  } = be(m, t), { isOpen: c, closeMenu: f, openMenu: N, toggleMenu: F } = Ie(
    x,
    h,
    E,
    i
  ), D = ke(
    C,
    h,
    !c
  ), [g, L] = Ee(n, s), k = _(
    (w) => g.has(w),
    [g]
  ), K = _(
    (w) => {
      const y = w || r().value;
      if (u) {
        k(y) ? g.delete(y) : g.add(y), L(g);
        const M = t.filter(
          (V) => g.has(V.value)
        );
        l?.(M), d && f(!0);
      } else
        k(y) ? (L(/* @__PURE__ */ new Set()), l?.([])) : (L(/* @__PURE__ */ new Set([y])), l?.(
          t.filter((M) => M.value === y)
        )), f(!0);
    },
    [
      r,
      k,
      g,
      L,
      t,
      l,
      d,
      f,
      u
    ]
  ), q = _(() => ({
    id: `dropdown-${m}-button`,
    ref: x,
    "aria-expanded": c,
    "aria-haspopup": "listbox",
    onClick: F,
    onKeyUp: () => {
      D.current = !1;
    },
    onKeyDown: (w) => {
      if (D.current = !0, w.key === "ArrowDown")
        return w.preventDefault(), N();
    },
    disabled: p
  }), [m, c, F, p, D, N]), j = _(() => ({
    id: `dropdown-${m}-list`,
    ref: h,
    tabIndex: -1,
    role: "listbox",
    "aria-activedescendant": C,
    "data-open": c,
    onKeyUp: () => {
      D.current = !1;
    },
    onKeyDown: (w) => (D.current = !0, he(
      w,
      t.length,
      E,
      K
    ))
  }), [
    m,
    C,
    c,
    D,
    t.length,
    E,
    K
  ]), G = _(
    ({ item: w, index: y }) => {
      const M = b === y, V = k(w);
      return {
        id: z(m, w),
        role: "option",
        "aria-selected": V,
        "aria-current": M,
        onClick: () => K(w),
        onMouseEnter: () => E(y),
        onTouchStart: () => E(y)
      };
    },
    [
      b,
      k,
      m,
      K,
      E
    ]
  ), J = $(
    () => t.filter((w) => g.has(w.value)),
    [t, g]
  );
  return {
    uuid: m,
    isOpen: c,
    highlightedIndex: b,
    selectedItemsValues: g,
    selectedItems: J,
    checkSelected: k,
    openMenu: N,
    closeMenu: f,
    getMenuProps: j,
    getMenuItemProps: G,
    getUpdatedToggleButtonProps: q
  };
}
const Ne = H(function(e, t) {
  const n = S(null), {
    label: s,
    name: d,
    items: i = [],
    emptyMessage: l = "No items available",
    size: u = "normal",
    isMulti: p = !0,
    className: B,
    buttonClassName: m,
    listClassName: x,
    autoFocus: h = !1,
    showFilterInput: b = !1,
    disabled: C
  } = e, {
    uuid: E,
    isOpen: r,
    highlightedIndex: c,
    selectedItems: f,
    getMenuProps: N,
    getMenuItemProps: F,
    checkSelected: D,
    getUpdatedToggleButtonProps: g,
    openMenu: L,
    closeMenu: k
  } = ye(e);
  return Y(
    t,
    () => ({
      open: L,
      close: k,
      isOpen: r
    }),
    [L, k, r]
  ), Z([n], k, { disabled: !r }), /* @__PURE__ */ a.createElement(
    "div",
    {
      id: `dropdown-${E}`,
      className: v(I.dropdown, B),
      "data-testid": "dropdown",
      ref: n
    },
    /* @__PURE__ */ a.createElement(
      me,
      {
        isOpen: r,
        label: s,
        selectedItems: e.selectedItems || f,
        isLarge: u === "large",
        isMulti: p,
        className: m,
        ...g(),
        autoFocus: h
      }
    ),
    !C && /* @__PURE__ */ a.createElement(
      we,
      {
        isOpen: r,
        items: i,
        getItemProps: F,
        checkSelected: D,
        highlightedIndex: c,
        emptyMessage: l,
        isMulti: p,
        className: x,
        name: d,
        ...N(),
        showFilterInput: b
      }
    )
  );
});
function Me() {
  return S(null);
}
export {
  Ne as D,
  Me as u
};
//# sourceMappingURL=Dropdown-cd8250f9.mjs.map
